import axios from "axios";
import { GET_ALL_PROFILE_LANGUAGES } from "./types";
const keys = require("../config/keys");

export const getAllProfileLanguages = () => async dispatch => {
  await axios({
    method: "get",
    url: keys.ServicePath + "/api/AdmissionForm/GetAllProfileLanguages"
  })
    .then(res => {
      if (res.data.success) {
        try {
          dispatch({
            type: GET_ALL_PROFILE_LANGUAGES,
            payload: res.data.data
          });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};



// WEBPACK FOOTER //
// ./src/actions/getAllProfileLanguages.js